import React from 'react';
import { formatRwf } from '../../../utils/currency';
const staff = [{
  name: 'Aline Uwimana',
  branch: 'Remera',
  sales: 486000,
  share: 100
}, {
  name: 'Eric Habimana',
  branch: 'Kimironko',
  sales: 412500,
  share: 85
}, {
  name: 'Diane Mukamana',
  branch: 'Remera',
  sales: 351000,
  share: 72
}, {
  name: 'Patrick Nsengiyumva',
  branch: 'Nyamirambo',
  sales: 298000,
  share: 61
}];
const branches = [{
  name: 'Remera',
  value: 837000
}, {
  name: 'Kimironko',
  value: 412500
}, {
  name: 'Nyamirambo',
  value: 298000
}];
export function StaffSalesScreen() {
  return <div className="w-full max-w-[400px] rounded-[14px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-1381" data-mp="slfg2c4mubam">
      <div className="flex items-baseline justify-between" data-id="element-1382" data-mp="jio2o6s755gc">
        <p className="text-[14px] font-semibold text-ink" data-id="element-1383" data-mp="jk7m2695fwmc">Today by staff</p>
        <span className="text-[12px] text-ink-muted" data-id="element-1384" data-mp="2hwps1ao4du3u">Live</span>
      </div>
      <ul className="mt-4 space-y-3" data-id="element-1385" data-mp="2dw5sk0g2qeej">
        {staff.map(s => <li key={s.name} data-id="element-1386" data-mp="2worhzl2zgxo0">
            <div className="flex items-center justify-between text-[12.5px]" data-id="element-1387" data-mp="2woi2wsjh8ax3">
              <span className="flex items-center gap-2" data-id="element-1388" data-mp="31nkylmdkh4se">
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-brand-soft text-[10px] font-semibold text-brand" data-id="element-1389" data-mp="31p5t5bzvsnq9">
                  {s.name.split(' ').map(p => p[0]).join('')}
                </span>
                <span className="font-medium text-ink" data-id="element-1390" data-mp="3ffssn6dguhne">{s.name}</span>
                <span className="text-ink-muted" data-id="element-1391" data-mp="3kelu20fhai77">· {s.branch}</span>
              </span>
              <span className="font-semibold text-ink" data-id="element-1392" data-mp="36nh1tjefws6w">{formatRwf(s.sales)}</span>
            </div>
            <div className="ml-8 mt-1.5 h-1.5 overflow-hidden rounded-full bg-canvas-line" data-id="element-1393" data-mp="3ao0y6kr6vrrz">
              <div className="h-full rounded-full bg-brand" style={{
            width: `${s.share}%`
          }} data-id="element-1394" data-mp="28ze1iya4i29" />
            </div>
          </li>)}
      </ul>
      <div className="mt-5 grid grid-cols-3 divide-x divide-canvas-line rounded-[10px] bg-canvas-warm py-2.5" data-id="element-1395" data-mp="710n6w05hso2">
        {branches.map(b => <div key={b.name} className="px-3" data-id="element-1396" data-mp="ctuns7jvjbn9">
            <p className="text-[11px] text-ink-muted" data-id="element-1397" data-mp="cv5sqap22pfy">{b.name}</p>
            <p className="mt-0.5 text-[12px] font-semibold text-ink" data-id="element-1398" data-mp="7u8bq1fs81g1">{formatRwf(b.value)}</p>
          </div>)}
      </div>
    </div>;
}